export const centToDollar = (fen) => {
  let num = fen;
  num = fen * 0.01;
  num += '';
  let reg = num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g;
  num = num.replace(reg, '$1');
  num = toDecimal2(num)

  return (num || '0').replace('.00', '')
};

export const toDecimal2 = (x) => {
  let f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  f = Math.round(x * 100) / 100;
  let s = f.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
}
const _padStart = function _padStart(num) {
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var ch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';

  var output = '' + num;

  while (output.length < len) {
    output = '' + ch + output;
  }
  return output;
};
export const Formatter = {
  format: function format(millis) {
    var formatStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

    var d = new Date(millis);

    return formatStr.replace('YYYY', d.getFullYear()).replace('MM', _padStart(d.getMonth() + 1)).replace('DD', _padStart(d.getDate())).replace('HH', _padStart(d.getHours())).replace('mm', _padStart(d.getMinutes()));
  }
};